import React, { useEffect } from 'react'
import { GridItem, MuiTypography } from '../../../../components/storybook'

const textWarning = {
    conversionAndTransfer: ` Ao converter seus programCurrencyName para
                carteira digital, você poder utilizar o valor como um método de
                pagamento para suas compras ou realizar solicitações de
                transferências.`,
    conversion: 'Ao converter seus pontos para carteira digital, você pode utilizar o valor como um método de pagamento para realizar as suas compras.'
}

export function Warning({ GeneralRules }) {

    const getTextWarning = () => {
        if (GeneralRules?.allowPointsConversion && GeneralRules?.allowTransfer && GeneralRules?.allowPointsConversionWithdrawal) {
            return textWarning['conversionAndTransfer']?.replace('programCurrencyName', localStorage?.programCurrencyName)
        }
        if (GeneralRules?.allowPointsConversion) {
            return textWarning['conversion']
        }
    }
    return (
        <GridItem xs={12} sm={12} md={12} lg={12} mb={3}>
            <MuiTypography
                color="#333333"
                fontSize="14px"
                sx={{ lineHeight: 1.8 }}
            >
                {getTextWarning()}
            </MuiTypography>{' '}
            <MuiTypography
                color="#333333"
                fontSize="14px"
                sx={{ lineHeight: 1.8 }}
            >
                {/* Não existe o campo mínimo para conversão nas regras gerais */}
                Valor mínimo para conversão é de R$ 1,00
            </MuiTypography>
        </GridItem>
    )
}
